import apiRequest from './request';

export interface ChatHistoryItem {
    id: number;
    creator: number;
    chatId: string;
    chatTitle: string;
    chatHistory: Array<{
        user: string;
        assistant: string;
    }>;
    createdAt: string;
    updatedAt: string;
}

export interface ChatHistoryResponse {
    statusCode: number;
    response?: {
        message: string;
        data: ChatHistoryItem | ChatHistoryItem[];
    };
}

export interface PaginatedChatHistoryResponse {
    statusCode: number;
    response?: {
        message: string;
        data: ChatHistoryItem[];
        pagination: {
            page: number;
            limit: number;
            total: number;
            pages: number;
        };
    };
}

class ChatHistoryService {
    /**
     * Create a new chat history
     */
    async createChatHistory(
        chatId: string,
        chatTitle: string,
        chatHistory: Array<{ user: string; assistant: string }>,
    ) {
        return apiRequest.request<ChatHistoryResponse>({
            method: 'post',
            url: '/podus-ai/chat-history',
            data: {
                chatId,
                chatTitle,
                chatHistory,
            },
        });
    }

    /**
     * Get all chat histories with pagination
     */
    async getChatHistories(page: number = 1, limit: number = 20) {
        return apiRequest.request<PaginatedChatHistoryResponse>({
            method: 'get',
            url: '/podus-ai/chat-history',
            params: {
                page,
                limit,
            },
            headers: {
                'Cache-Control': 'no-cache, no-store, must-revalidate',
                'Pragma': 'no-cache',
                'Expires': '0',
            },
        });
    }

    /**
     * Get a specific chat history by chatId
     */
    async getChatHistoryById(chatId: string) {
        return apiRequest.request<ChatHistoryResponse>({
            method: 'get',
            url: `/podus-ai/chat-history/${chatId}`,
            headers: {
                'Cache-Control': 'no-cache, no-store, must-revalidate',
                'Pragma': 'no-cache',
                'Expires': '0',
            },
        });
    }

    /**
     * Update an existing chat history
     */
    async updateChatHistory(
        chatId: string,
        chatTitle: string,
        chatHistory: Array<{ user: string; assistant: string }>,
    ) {
        return apiRequest.request<ChatHistoryResponse>({
            method: 'post',
            url: `/podus-ai/chat-history`,
            data: {
                chatTitle,
                chatHistory,
                chatId,
            },
        });
    }
}

export default new ChatHistoryService();
